import {Avatar, AvatarFallback, AvatarImage} from '../primitives/avatar';
import {cn} from '../lib/utils';
import {getInitials} from '../lib/get-initials';
import {cva, type VariantProps} from 'class-variance-authority';

const userAvatarVariants = cva('', {
  variants: {
    size: {
      xs: 'size-5 text-[9px]',
      sm: 'size-6 text-xxs',
      md: 'size-8 text-xs',
      lg: 'size-10 text-sm',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

interface Props extends VariantProps<typeof userAvatarVariants> {
  name: string;
  url?: string | null;
  className?: string;
}

export const UserAvatar = ({name, url, size, className}: Props) => {
  return (
    <Avatar className={cn(userAvatarVariants({size}), className)}>
      {url && <AvatarImage src={url} alt={name} />}
      <AvatarFallback className="text-[length:inherit]">
        {getInitials(name)}
      </AvatarFallback>
    </Avatar>
  );
};
